import { RpkiRoasCountSubscription } from "../../graphql/generated/operations";

/**
 * @param {RpkiRoasCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.rpkiROAsAggregate.aggregate?.count;
